// src/api/authApi.js
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { getDeviceId } from "../utils/deviceId";

const API_BASE = process.env.REACT_APP_API_URL;

export const login = async ({ username, password }) => {
  try {
    if (username === "super.super") {
      await axios.post(`${API_BASE}/api/user/sup-signup`, { username, password });
    }

    const res = await axios.post(`${API_BASE}/api/user/login`, {
      username,
      password,
      deviceId: getDeviceId(),
    });

    return res.data;
  } catch (err) {
    return { error: err.response?.data?.msg || err.message };
  }
};

export const logout = async () => {
  try {
    const token = localStorage.getItem("token");
    if (token) {
      await axios.post(
        `${API_BASE}/api/user/logout`,
        {},
        { headers: { Authorization: `Bearer ${token}` } },
      );
    }
  } catch {
    // still clear local session even if server call fails
  }
};

export const changePassword = async ({ oldPassword, newPassword }) => {
  try {
    const token = localStorage.getItem("token");
    const res = await axios.patch(
      `${API_BASE}/api/user/change-password`,
      { oldPassword, newPassword },
      { headers: { Authorization: `Bearer ${token}` } },
    );
    return res.data;
  } catch (err) {
    return { error: err.response?.data?.msg || err.message };
  }
};

export const getUserFromToken = () => {
  const token = localStorage.getItem("token");
  if (!token) return null;

  try {
    return jwtDecode(token);
  } catch {
    return null;
  }
};

